import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-storages',
    templateUrl: './storages.component.html',
    styleUrls: ['./storages.component.scss']
})
export class StoragesComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
